import React, { useState } from "react";
import TransactionLoader from "../../../../loader/TransactionLoader";
import { Dropdown } from "react-materialize";
import {
  Area,
  ComposedChart,
  ResponsiveContainer,
  XAxis,
  Tooltip,
} from "recharts";

function AmountCreditedChart({ loadings, creditRecord }) {
  const [number, setNumber] = useState(3);

  if (loadings) {
    return <TransactionLoader />;
  }

  return (
    <div
      className="white full-width"
      style={{
        borderRadius: "12px",
        boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
        padding: "10px 10px 0 10px",
      }}
    >
      <div
        className={`
           flex space-between mb-1`}
      >
        <h5 className="margin-0px">Amount Credited</h5>

        <Dropdown
          id="ammount-credited-monthsDropdown"
          trigger={
            <div
              className="valign-wrapper align-center cover grey lighten-3 font-cercular-bold black-text"
              style={{ padding: "5px 25px" }}
            >
              <p
                style={{
                  fontSize: "14px",
                }}
              >
                Last {number} Months
              </p>
              <span
                class="material-icons-outlined"
                style={{ marginLeft: "0.5rem" }}
              >
                keyboard_arrow_down
              </span>
            </div>
          }
        >
          <span onClick={() => setNumber(3)}>3 months</span>
          <span onClick={() => setNumber(6)}>6 Months</span>
          <span onClick={() => setNumber(12)}>1 Year</span>
          <span onClick={() => setNumber(24)}>2 Years</span>
        </Dropdown>
      </div>

      <ResponsiveContainer width="100%" height={175}>
        <ComposedChart data={creditRecord}>
          {/* <CartesianGrid verticalPoints={[-1]} /> */}
          <XAxis dataKey="date" />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="totalAmount"
            stroke="#6A0DAD"
            fillOpacity={1}
            fill="url(#colorUvv)"
          />

          <defs>
            <linearGradient id="colorUvv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#6A0DAD" stopOpacity={0.9} />
              <stop offset="95%" stopColor="#6A0DAD" stopOpacity={0.4} />
            </linearGradient>
          </defs>
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="cover valign-wrapper p-1 grey lighten-5" style={{}}>
        <span>
          <p>{`${label}`}</p>
          <p>
            <span className="red-text">Credit Amount:</span>
            {` ${payload[0].value}`}
          </p>
        </span>
      </div>
    );
  }
};

export default AmountCreditedChart;
